import { Button } from '@mui/material'
import React, { useRef, useEffect, useState } from 'react'
import QRCodeStyling, { DotType, Options } from 'qr-code-styling'

const Qr = (props: any) => {
  const { url, variant, disableDownload, qrSize, image } = props

  const getOptions = (data: string, isLarger?: boolean) => {
    const size = qrSize || (isLarger ? 1000 : 300);
    const output: any = {
      margin: 10,
      dotsOptions: {
        // Stays literal: qr-code-styling paints the modules to canvas (no CSS
        // vars) and the same value is baked into the downloaded PNG, which has
        // to be scannable black-on-white regardless of the app theme.
        color: '#000',
        type: 'square' as DotType,
      },
      data,
      width: size,
      height: size,
    }
    if (image) output.image = image;
    return output;
  };
  
  const [options, setOptions] = useState<Options>(getOptions(url));
  const [optionsB, setOptionsB] = useState<Options>(getOptions(url, true))
  const [qrCode] = useState<QRCodeStyling>(new QRCodeStyling(options))
  const [qrCodeB] = useState<QRCodeStyling>(new QRCodeStyling(optionsB))
  const ref = useRef<HTMLDivElement>(null)
  const ref2 = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      qrCode.append(ref.current)
    }
  }, [qrCode, ref])

  useEffect(() => {
    if (!qrCode) return
    qrCode.update(options)
  }, [qrCode, options])

  useEffect(() => {
    if (!qrCode) return
    qrCode.update(options)
  }, [qrCodeB, optionsB])

  useEffect(() => {
    if (url) {
      setOptions(getOptions(url));
      setOptionsB(getOptions(url, true));
    }
  }, [props]);

  const onDownloadClick = () => {
    if (!qrCode) return
    qrCodeB.download({
      extension: 'png',
    })
  }

  return (
    <>
      <div className="qr" ref={ref} />
      <div className="qr" ref={ref2} />
      {!disableDownload && (
        <Button onClick={onDownloadClick} size="small" type="submit" variant={variant || 'contained'} disableElevation style={{marginBottom:'10px'}}>
          DOWNLOAD QR
        </Button>
      )}
    </>
  )
}

export default Qr
